export default {
  props: {
    /**
      * Icon image sourcing strategy (singular, basic, custom)
      * Singular - Single icons used that don't change state
      * Basic - Icons that change based on states and events
      * Custom - Icons for UI provided from website stylesheet
      */
    iconSourcing: {type: String, default: 'singular'}
  }
};
